import { Injectable } from '@angular/core';

import { Parametres } from 'src/environments/parametres';

import { ParametersService } from './parameters.service';

export interface StatusInfo {
  displayText: string;
  cssClass: string;
  hexColor: string;
}

@Injectable({
  providedIn: 'root',
})
export class StatusFormatterService {
  private readonly statusClassMap: Record<string, string> = {
    'Not Issued': 'status-inactive',
    Issued: 'status-active',
    Redeemed: 'status-inactive',
    Expired: 'status-inactive',
    Blacklisted: 'status-inactive',
    'Issue Refunded': 'status-refunded',
  };

  private readonly statusColorMap: Record<string, string> = {
    'status-active': '#4CAF50',
    'status-inactive': '#F44336',
    'status-default': '#9E9E9E',
    'status-refunded': '#dc3545',
  };

  private readonly statusMap: Record<string, string> = {
    'Not Issued': 'Inactif',
    Issued: 'Actif',
    Redeemed: 'Consommée',
    Expired: 'Expirée',
    Blacklisted: 'Blacklist',
    'Issue Refunded': 'Remboursé',
  };

  constructor(private parametersService: ParametersService) {}

  /**
   * Formats status with translation and styling information
   */
  formatStatus(status?: string): StatusInfo {
    if (!status) {
      return {
        displayText: '',
        cssClass: 'status-default',
        hexColor: this.statusColorMap['status-default'],
      };
    }

    const displayText = this.getDisplayText(status);
    const cssClass = this.getCssClass(status);
    const hexColor = this.statusColorMap[cssClass] || this.statusColorMap['status-default'];

    return {
      displayText,
      cssClass,
      hexColor,
    };
  }

  /**
   * Gets translated display text for status
   */
  getDisplayText(status: string): string {
    const langue = this.parametersService.get(Parametres.LANGUE) as string;
    const isFrench = langue === 'fr';

    if (this.statusMap[status] && isFrench) {
      return this.statusMap[status];
    }

    return status;
  }

  /**
   * Gets CSS class for status
   */
  getCssClass(status: string): string {
    return this.statusClassMap[status] || 'status-default';
  }

  /**
   * Gets hex color for status
   */
  getHexColor(status: string): string {
    const cssClass = this.getCssClass(status);
    return this.statusColorMap[cssClass] || this.statusColorMap['status-default'];
  }
}
